import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import CheckedIcon from './CheckedIcon';
import UncheckedIcon from './UncheckedIcon';

import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Radio');

function Radio({
    classes: classesProp,
    className: classNameProp,
    isDisabled,
    overrides: overridesProp,
    checked = false,
    isEnriched = false,
    onChange = () => {},
}) {
    const classes = useClasses(useStyles, classesProp);
    // Overrides
    const override = getOverrides(overridesProp, Radio.overrides);

    // Classes
    const rootClassName = classnames(
        classes.root,
        {
            [classes.disabled]: isDisabled,
        },
        classNameProp,
    );

    const rootProps = {
        className: rootClassName,
        onClick: !isDisabled ? onChange : undefined,
    };

    return (
        <div {...rootProps} {...override.root}>
            {checked && <CheckedIcon isEnriched={isEnriched} {...override.svg} />}
            {!checked && <UncheckedIcon isEnriched={isEnriched} {...override.svg} />}
            <input
                className={classes.input}
                onChange={!isDisabled ? onChange : undefined}
                type="radio"
                checked={checked ? 'checked' : ''}
                disabled={isDisabled ? 'disabled' : ''}
                {...override.input}
            />
        </div>
    );
}

Radio.overrides = ['root', 'input', 'svg'];

Radio.propTypes = {
    /** Determines whether the radio button is selected */
    checked: PropTypes.bool,
    /** Custom CSS class for styling */
    className: PropTypes.string,
    /** When true, the radio button appears grayed out and doesn't respond to user interaction */
    isDisabled: PropTypes.bool,
    /** When true, fills the radio SVG with the promotional gradient to indicate AI-enriched content */
    isEnriched: PropTypes.bool,
    /** Function called when the radio button is clicked */
    onChange: PropTypes.func,
    /** Object with custom style overrides for the component parts */
    overrides: PropTypes.object,
};

export default React.memo(Radio);
